import {
  EDIT_EMAIL,
  GET_EMAILS,
  ADD_EMAIL,
} from "../../shared/constants/ActionTypes";

const initialEmails = {
  emails: [],
  emailCount: 0,
};

const emailsReducer = (state = initialEmails, action) => {
  switch (action.type) {
    case GET_EMAILS:
      return {
        ...state,
        emails: action.payload.emails,
        emailCount: action.payload.emailCount,
      };
    case ADD_EMAIL:
      return {
        ...state,
        emails: state.emails.push(action.payload),
        emailCount: (state.emailCount += 1),
      };

    case EDIT_EMAIL:
      return {
        ...state,
        emails: state.emails.map((email) => {
          if (email.id === action.payload.id) {
            return action.payload;
          } else {
            return email;
          }
        }),
      };
    default:
      return state;
  }
};

export default emailsReducer;
